import script from "./Service.vue?vue&type=script&setup=true&lang=js"
export * from "./Service.vue?vue&type=script&setup=true&lang=js"

import "./Service.vue?vue&type=style&index=0&id=4886e6b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4886e6b1"]])

export default __exports__